import { Store, Module, ActionContext } from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'

interface BackShopOrderState extends ListState<any> {

}

class BackOrderMutations extends ListMutations<any>{

}
class BackShopOrder extends ListModule<BackShopOrderState, any, any>{
    state = {
        totalCount: 0,
        currentPage: 1,
        pageSize: 10,
        list: new Array<any>(),
        loading: false,
        ids: [],
        id: 0
    }
    actions = {
        async getAll(context: ActionContext<BackShopOrderState, any>, payload: any) {
            context.state.loading = true;
            let reponse = await Ajax.get('/api/services/app/DistributionOrder/GetDistributionOrderList', { params: payload.data });
            context.state.loading = false;
            let page = reponse.data.result as PageResult<any>;
            context.state.totalCount = page.totalCount;
            context.state.list = page.items;
        },
        //async PurchaseOperation(state: any, payload: any) {
        //    let rep = await Ajax.post('/api/services/app/FrontDistributionOrder/PurchaseOperation', payload.data);
        //},
    };
    mutations = {
        setCurrentPage(state: BackShopOrderState, page: number) {
            state.currentPage = page;
        },
        setPageSize(state: BackShopOrderState, pagesize: number) {
            state.pageSize = pagesize;
        }
    }
}

const backShopOrder = new BackShopOrder();
export default backShopOrder;